<script lang="ts">
  import { StoryblokComponent } from '@storyblok/svelte';
  import type { BlogCategoryBlock } from '@storyblok-types';

  const { blok }: { blok: BlogCategoryBlock } = $props();
</script>

{#each blok.body ?? [] as item (item._uid)}
  <StoryblokComponent blok={item} />
{/each}
